import {Component} from '@angular/core';
import { UrlService } from '../../services/url.service';
import {PropertyService} from '../admin/property/services/property.service';
import {ResidentService} from '../../services/resident.service';


declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'contact-us-modal',
    templateUrl: './contact-us-modal.component.html',
    styleUrls: ['./contact-us-modal.component.scss']
})
export class ContactUsModalComponent {

    constructor(
        public urlService: UrlService,
        public residentService: ResidentService,
        public propertyService: PropertyService
    ) {}

    hideModal() {
        this.residentService.contactUsModalShow = false;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/contact-us-modal/contact-us-modal.component.ts